import { useMemo, useEffect, useState, useCallback, ComponentType } from 'react';
import withPollingHandler from '@mindtickle/hocs/withPollingHandler';

const Dummy = () => null;

type remoteModuleReturnType = { PollingHandler: ComponentType<any>; POLL_PROCESS_ID: string };

const PollingHandlers = ({ remoteModule }: { remoteModule: Promise<remoteModuleReturnType> }) => {
  const [module, setModule] = useState<remoteModuleReturnType | null>(null);

  const load = useCallback(async () => {
    const module = await remoteModule;
    setModule(module);
  }, [remoteModule]);

  useEffect(() => {
    !module && load();
  }, [load, module]);

  const Component = useMemo(
    () =>
      module
        ? withPollingHandler({
            PollingHandler: module.PollingHandler,
            processId: module.POLL_PROCESS_ID,
          })(Dummy)
        : Dummy,
    [module]
  );
  return <Component />;
};

export default PollingHandlers;
